export default __webpack_public_path__ + "static/26c4d55b-e131-490b-864d-1a5743b90b33-f1d39b65ae039a1841678ea0360e2834.png";